import React, { useState, useRef } from 'react';

const TransformSection = () => {
  const [sliderPosition, setSliderPosition] = useState(50);
  const containerRef = useRef(null);
  const isDragging = useRef(false);

  const handleMove = (clientX) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const x = clientX - rect.left;
    const percentage = Math.max(0, Math.min(100, (x / rect.width) * 100));
    setSliderPosition(percentage);
  };

  const handleMouseDown = () => {
    isDragging.current = true;
  };

  const handleMouseUp = () => {
    isDragging.current = false;
  };

  const handleMouseMove = (e) => {
    if (isDragging.current) {
      handleMove(e.clientX);
    }
  };

  const handleTouchMove = (e) => {
    handleMove(e.touches[0].clientX);
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Transform Your Smile
          </h2>
        </div>

        {/* Before/After Comparison */}
        <div className="max-w-4xl mx-auto">
          <div
            ref={containerRef}
            className="relative aspect-[16/9] rounded-2xl overflow-hidden shadow-2xl cursor-ew-resize"
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
            onMouseMove={handleMouseMove}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleMouseUp}
          >
            {/* Before Image */}
            <div className="absolute inset-0">
              <img
                src="https://roseville-smile-revamp.lovable.app/assets/km-before-BIngbVaO.jpg"
                alt="Before"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-6 left-6 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-lg">
                <span className="font-bold text-gray-900">Before</span>
              </div>
            </div>

            {/* After Image (clipped) */}
            <div
              className="absolute inset-0 overflow-hidden"
              style={{ clipPath: `inset(0 ${100 - sliderPosition}% 0 0)` }}
            >
              <img
                src="https://roseville-smile-revamp.lovable.app/assets/km-after-Bfrf6VpU.jpg"
                alt="After"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-6 right-6 bg-gradient-to-r from-cyan-500 to-cyan-600 text-white px-4 py-2 rounded-lg">
                <span className="font-bold">After</span>
              </div>
            </div>

            {/* Slider Handle */}
            <div
              className="absolute top-0 bottom-0 w-1 bg-white shadow-lg cursor-ew-resize"
              style={{ left: `${sliderPosition}%`, transform: 'translateX(-50%)' }}
            >
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 bg-white rounded-full shadow-xl flex items-center justify-center">
                <div className="flex items-center gap-0.5">
                  <div className="w-0.5 h-4 bg-gray-400 rounded" />
                  <div className="w-0.5 h-4 bg-gray-400 rounded" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Free Consultation CTA */}
        <div className="mt-16 max-w-lg mx-auto bg-gradient-to-br from-amber-50 to-amber-100 rounded-2xl p-8 text-center border border-amber-200">
          <h3 className="text-2xl font-bold text-gray-900 mb-2">FREE CONSULTATION</h3>
          <p className="text-gray-600 mb-4">Limited time offer while spots are open!</p>
          <a
            href="tel:9167731122"
            className="inline-flex items-center justify-center gap-2 bg-amber-500 hover:bg-amber-600 text-white font-bold px-6 py-3 rounded-lg transition-all duration-300"
          >
            Call Now: (916) 773-1122
          </a>
        </div>
      </div>
    </section>
  );
};

export default TransformSection;
